import { useIntl } from 'react-intl'

export default function useFormTexts() {
	const { formatMessage } = useIntl()

	const label = (labelCode, values) => formatMessage({ id: labelCode, values })

	const error = (fieldError, values = {}) => {
		if (!fieldError?.message) {
			return ' '
		}
		if (typeof fieldError.message === 'object') {
			return formatMessage({ id: fieldError.message.key }, { ...fieldError.message.values, ...values }) || ' '
		} else {
			return formatMessage({ id: fieldError.message }, values) || ' '
		}
	}

	return {
		error,
		label
	}
}
